// Forms on signed out pages (login, "Log in with Google", forgot and reset password) get a fresh CSRF token right
// before submitting. The token rendered into the page is no longer valid once another tab logs out or logs in.
//
// Call on pages loaded while signed out.
export function refreshCsrfTokenOnSubmit(): void {
  document.querySelectorAll<HTMLFormElement>('form').forEach((form) => {
    const input = form.querySelector<HTMLInputElement>('input[name="authenticity_token"]');
    if (!input) return;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      try {
        const response = await fetch('/csrf_token', { credentials: 'same-origin', cache: 'no-store' });
        const { token } = await response.json();
        if (token) input.value = token;
      } catch {
        // Submit with the token already in the form
      }
      // Does not trigger this listener again
      form.submit();
    });
  });
}
